<template>
  <div ref="addFeeTaxesDialogContainer">
    <ed-modal
      :show="show"
      :title="title"
      primary-button="Save"
      secondary-button="Cancel"
      @close="onClose"
      @validate="onSave"
      :validation="validation"
      :closeOnEsc="true"
      name='allocate_bu_cc_pair_popup'
    >
      <div slot="body">
        <section class="col-md-10 no-pad">
          Allocate to Business Unit and Cost Center for the following items:
          <ul v-for="item in selectedItemNames" :key="item">
            <li>{{item}}</li>
          </ul>
          <div class="row col-md-10 no-pad">
            <ed-select
              field-label="Business Unit and Cost Center"
              placeholder="Select a Business Unit and Cost Center"
              :options="buCCPairs"
              required="required"
              label="name"
              track-by="key"
              v-model="formData.draftItem.buCCPair"
              @select="buCCPairsSelected($event)"
              :error="doDisplayError"
              :helptip-header="doDisplayError && 'Error' || ''"
              :helptip-body="doDisplayError && 'Please select a Business Unit and Cost Center' || ''"
              name='allocate_to_cost_centers'
            />
          </div>
        </section>
        <div class="clear"></div>
      </div>
    </ed-modal>
  </div>
</template>

<script>

import LineItemStore from './LineItemStore.js'
import { EventBus } from '@/event-bus'

export default {
  name: 'AllocateToBUCCPair',

  props: {
    model: Object,
    eventHub: Object,
    dependencies: Object,
    eventUniqueId: String
  },

  data() {
    return {
      formData: {
        draftItem: {
          buCCPair: {}
        }
      },
      show: true,
      title: 'Allocate to Business Unit and Cost Center',
      validation: true,
      buCCPairs: [],
      selectedRows: [],
      selectedItemNames: [],
      doDisplayError: false
    }
  },

  created() {
    var dialog = this
    this.title = 'Allocate to Business Unit and Cost Center'
    this.selectedRows = this.model.selectedRows
    this.selectedItemNames = this.model.selectedRows.map(item => {
      return item.data.name
    })

    this.store()
      .getCostCentersBusinessUnits(
        this.model.programId
      )
      .then(response => {
        dialog.bindBUCCPairs(response.data)
      })
  },

  methods: {
    buCCPairsSelected(e) {
      this.formData.draftItem.buCCPair = {
        key: e.key,
        name: e.name
      }
      this.doDisplayError = false
    },

    store() {
      return new LineItemStore(this.api)
    },

    onClose() {
      this.show = false
    },

    onSave() {
      if (!this.isValid()) return

      EventBus.$emit('onSaveAllocateToBUCCPair', {
        data: {
          buCCPair: this.formData.draftItem.buCCPair,
          itemsToUpdate: this.selectedRows.map(item => { return item.rowIndex }),
          eventUniqueId: this.eventUniqueId
        }
      })
      this.$nextTick(() => {
        this.show = false
      })
    },

    isValid() {
      if (this.formData.draftItem.buCCPair &&
        JSON.stringify(this.formData.draftItem.buCCPair) !== JSON.stringify({}) &&
        this.formData.draftItem.buCCPair.name) {
        this.doDisplayError = false
        return true
      }

      this.doDisplayError = true
      return false
    },

    bindBUCCPairs(data) {
      var buCCPairs = data.costCentersAndBusinessUnit.mixedCostCentersAndBusinessUnits

      if (buCCPairs !== null && buCCPairs !== undefined && buCCPairs.length > 0) {
        this.buCCPairs = buCCPairs

        if (this.selectedRows.length === 1) {
          let selectedPair = this.selectedRows[0].data.costCenterAndBusinessUnit
          let pair = {
            key: selectedPair.costCenterAndBusinessUnitKey,
            name: selectedPair.costCenterAndBusinessUnitName
          }

          this.formData.draftItem.buCCPair = {
            key: pair.key,
            name: pair.name
          }
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/_modules/I2P/dialogs/LineItem/AllocateToBUCCPair.vue